(function () {
'use strict';

angular
    .module('personModule')
    .directive('person', directive);
        
directive.$inject = ['personService'];

function directive(personService) {
    return {
        scope: {
            personId: '=?',
            model: '=?',
            version: '=',
            withLink: '=?',
            layoutRatio: '=?',
            hasLoadedModel: '=?',
            isExternalUser: '=?'
        },
        template: '<div ng-include="getTemplateUrl()"></div>',
        controller: ['$scope', function ($scope) {

            $scope.getLayoutRatio = function () {
                if (_.isUndefined($scope.layoutRatio)) {
                    return {
                        photoColumn: 'col-md-3',
                        infosColumn: 'col-md-5',
                        supervisorColumn: 'col-md-4'
                    };
                }
                return _.isString($scope.layoutRatio) ? $scope.$eval($scope.layoutRatio) : $scope.layoutRatio;
            }
        }],
        link: function (scope, elem, attrs) {

            scope.getTemplateUrl = function () {
                return '/app/shared/person/personDirective-' + attrs.version + '.tpl.html';
            }

            if (_.isUndefined(scope.model)) {

                scope.$watch('personId', function (newValue, oldValue) {
                    if (newValue) {
                        personService
                            .getPersonByID(newValue)
                            .then(function (person) {
                                scope.employee = person;
                                scope.model    = person;
                                scope.hasLoadedModel = true;
                            });
                    }
                });
            }
            else {
                scope.employee = scope.model;
            }

            scope.$watch('model', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    scope.employee = scope.model;
                }
            });
        }
    }
}
})();